import { newValidator, validateUrl } from 'simple-valley'

export default class ImageClient {
  constructor({ proxyUrl }) {
    this.proxyUrl = proxyUrl
  }

  imageUrl(url, width, height, devicePixelRatio = 1) {
    let validator = newValidator({ url })
    validator = validateUrl(validator, 'url')
    if(!validator.isValid) return ''

    const maxRatio = 3
    devicePixelRatio = Math.ceil(devicePixelRatio)
    devicePixelRatio = devicePixelRatio > maxRatio ? maxRatio : devicePixelRatio
    width = Math.floor(width*devicePixelRatio)
    height = Math.floor(height*devicePixelRatio)
    return `${this.proxyUrl}/a/fit/${width}/${height}/sm/0/plain/${url}`
  }
}
